import React, { useState, useEffect, useRef } from "react";
import "./Home.css";
import { NavLink } from "react-router-dom";
import { BsLinkedin, BsGithub } from "react-icons/bs";
import { SiLeetcode } from "react-icons/si";
import { HiDownload, HiArrowRight } from "react-icons/hi";
import { useTypewriter, Cursor } from "react-simple-typewriter";

import PassportImage from "../../Assest/Image/passportSize.jpeg";
import About from "../About/About";
import Skill from "../Skill/Skill";
import Project from "../Project/Project";
import Contact from "../Contact/Contact";
import Resume from "../../Assest/Image/Resume.pdf";
import BackToTop from "../BackToTop";
import useCountUp from "../../hooks/useCountUp";

const Home = () => {
  const [text] = useTypewriter({
    words: [
      "Full-Stack Engineer",
      "React.js Developer",
      "Node.js Developer",
      "MERN Stack Developer",
    ],
    loop: {},
    typeSpeed: 80,
    deleteSpeed: 50,
  });

  const statsRef = useRef(null);
  const [statsVisible, setStatsVisible] = useState(false);

  useEffect(() => {
    const el = statsRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStatsVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold: 0.5 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const yearsCount = useCountUp(2, 1600, statsVisible);
  const usersCount = useCountUp(5, 1800, statsVisible);
  const projectsCount = useCountUp(10, 2000, statsVisible);

  return (
    <>
      <div className="home">
        <div className="left-side-home">
          <div className="home-badge">
            <span className="badge-dot" />
            Available for opportunities
          </div>

          <h1 className="home-name">Abhinav Kumar Pathak</h1>

          <p className="home-role">
            I'm a{" "}
            <span className="typed-text">{text}</span>
            <Cursor cursorStyle="|" />
          </p>

          <p className="home-desc">
            Full-Stack Software Engineer with 2+ years of experience building
            scalable web applications. Specialized in React.js, Node.js,
            PostgreSQL, and AWS — with a focus on real-time systems and
            performance.
          </p>

          <div className="home-stats" ref={statsRef}>
            <div className="stat-item">
              <span className="stat-number">{yearsCount}+</span>
              <span className="stat-label">Years Exp.</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">{usersCount}K+</span>
              <span className="stat-label">Users Served</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">{projectsCount}+</span>
              <span className="stat-label">Projects</span>
            </div>
          </div>

          <div className="home-actions-group">
            <div className="home-actions">
              <a href={Resume} download="Abhinav_Resume" className="btn-primary">
                <HiDownload />
                Download CV
              </a>
              <NavLink to="/project" className="btn-secondary">
                View Projects
                <HiArrowRight />
              </NavLink>
            </div>

            <div className="social-link">
              <ul className="unorderlink">
                <NavLink
                  to="https://www.linkedin.com/in/abhinav9984"
                  target="_blank"
                  className="social-icon-btn"
                  title="LinkedIn"
                >
                  <BsLinkedin />
                </NavLink>
                <NavLink
                  to="https://github.com/Abhinav4005"
                  target="_blank"
                  className="social-icon-btn"
                  title="GitHub"
                >
                  <BsGithub />
                </NavLink>
                <NavLink
                  to="https://leetcode.com/Abhinavpathak45/"
                  target="_blank"
                  className="social-icon-btn"
                  title="LeetCode"
                >
                  <SiLeetcode />
                </NavLink>
              </ul>
            </div>
          </div>
        </div>

        <div className="right-side-home">
          <div className="profile-wrapper">
            <div className="profile-ring" />
            <div className="profile-ring-inner" />
            <div className="profile-img-container">
              <img src={PassportImage} alt="Abhinav Kumar Pathak" />
            </div>
            <div className="profile-badge">
              <span className="profile-badge-icon">💼</span>
              <div className="profile-badge-text">
                <div className="profile-badge-title-row">
                  <strong>Eminence Technology</strong>
                  <span className="badge-live-dot" title="Current Role" />
                </div>
                <span>Software Engineer</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <About />
      <div className="section-divider" />
      <Skill />
      <div className="section-divider" />
      <Project />
      <div className="section-divider" />
      <Contact />
      <BackToTop />
    </>
  );
};

export default Home;
